"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _require = require("../helpers/strings"),
    splitOnASCIIWhitespace = _require.splitOnASCIIWhitespace,
    splitOnCommas = _require.splitOnCommas;

var _require2 = require("../helpers/svg/basic-types"),
    reserializeCommaSeparatedTokens = _require2.reserializeCommaSeparatedTokens,
    reserializeSpaceSeparatedTokens = _require2.reserializeSpaceSeparatedTokens;

var SVGStringList = require("../generated/SVGStringList");

var SVGTestsImpl =
/*#__PURE__*/
function () {
  function SVGTestsImpl() {
    _classCallCheck(this, SVGTestsImpl);
  }

  _createClass(SVGTestsImpl, [{
    key: "requiredExtensions",
    get: function get() {
      return SVGStringList.createImpl([], {
        element: this,
        attribute: "requiredExtensions"
      });
    }
  }, {
    key: "systemLanguage",
    get: function get() {
      return SVGStringList.createImpl([], {
        element: this,
        attribute: "systemLanguage"
      });
    }
  }]);

  return SVGTestsImpl;
}();

SVGTestsImpl.attributeRegistry = new Map([// https://svgwg.org/svg2-draft/struct.html#RequiredExtensionsAttribute
["requiredExtensions", {
  getValue: splitOnASCIIWhitespace,
  serialize: reserializeSpaceSeparatedTokens,
  initialValue: undefined
}], // https://svgwg.org/svg2-draft/struct.html#SystemLanguageAttribute
["systemLanguage", {
  getValue: splitOnCommas,
  serialize: reserializeCommaSeparatedTokens,
  initialValue: undefined
}]]);
exports.implementation = SVGTestsImpl;